function SSSlideDisplayer(config){
  if (typeof config === "undefined"){
    return;
  }
  this.config = config;
  this.slideOffsets = [];
  this.playerBgColor = config.playerBgColor || "jsplBgColorBigfoot";
  this.state = 'initialized';
  this.zoomIndex = 0;
  this._init();
}

SSSlideDisplayer.prototype._init = function(){
  var that = this;
  if(this.config.show_image_player){
   this.container = $('.stage');
 }else{
  this.container = $('<div/>').addClass('slideDisplayer ' + this.playerBgColor).appendTo(this.config.renderTo);
  this.showInitializer();
}
};

SSSlideDisplayer.prototype.hideInitializer = function(){
  if (!this.config.show_image_player) {
    //Don't remove the left/right navigation bands for presentations
    this.container.find('*').not('.pointly').remove();
  }
};

SSSlideDisplayer.prototype.error = function(jQueryDomObject){
  this.hideInitializer();
  jQueryDomObject.appendTo(this.container);
};

SSSlideDisplayer.prototype.zoomin = function(){
  var newZoomIndex = this.zoomIndex + 1;
  if (newZoomIndex === this.zoomLevels.length){
    return;
  }
  this.zoomIndex = newZoomIndex;
  this.setZoom(newZoomIndex);
  $(this).trigger('zoomchanged');
};

SSSlideDisplayer.prototype.zoomout = function(){
 if (this.zoomIndex === 0){
   return;
 }
 this.zoomIndex -= 1;
 this.setZoom(this.zoomIndex);
 $(this).trigger('zoomchanged');
};

SSSlideDisplayer.prototype.activate = function(){

};

SSSlideDisplayer.prototype.deactivate = function(){

};
SSSlideDisplayer.prototype.destroy = function(){
  this.container.remove();
};

SSSlideDisplayer.prototype._bindEvents = function() {
};

//update objects here as desired. pass objects to be
//updated in config.
SSSlideDisplayer.prototype.refresh = function(config){
  var that = this;
  $.each(config, function(property, value){
    if(that.config[property]){
      that.config[property] = value;
    }
  });
};

export default SSSlideDisplayer;